import React from 'react';
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Avatar,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  FaCheckCircle,
  FaClock,
  FaBan,
  FaExchangeAlt,
} from 'react-icons/fa';

export default function PointsHistory({ historyData = [], isMobile = false }) {
  const getCategoryColor = (category) => {
    switch(category) {
      case 'verified': return '#43a047';
      case 'pending': return '#ff9800';
      case 'spammed': return '#f44336';
      case 'redeemed': return '#7b1fa2';
      default: return '#666';
    }
  };

  const getCategoryIcon = (category) => {
    switch(category) {
      case 'verified': return <FaCheckCircle />;
      case 'pending': return <FaClock />;
      case 'spammed': return <FaBan />;
      case 'redeemed': return <FaExchangeAlt />;
      default: return <FaClock />;
    }
  };

  const getCategoryLabel = (category) => {
    switch(category) {
      case 'verified': return 'Verified';
      case 'pending': return 'Pending';
      case 'spammed': return 'Spammed';
      case 'redeemed': return 'Redeemed';
      default: return category;
    }
  };

  return (
    <Box mt={3}>
      <Paper sx={{ 
        borderRadius: '16px', 
        overflow: 'hidden',
        bgcolor: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(10px)',
      }}>
        {historyData && historyData.length > 0 ? (
          <List>
            {historyData.map((item, index) => (
              <React.Fragment key={item.id || index}>
                <ListItem
                  sx={{
                    '&:hover': {
                      bgcolor: 'rgba(46,125,50,0.04)',
                    },
                    transition: 'background 0.2s ease',
                    py: isMobile ? 1.5 : 2,
                    px: isMobile ? 1.5 : 3,
                  }}
                >
                  <ListItemAvatar>
                    <Avatar 
                      sx={{ 
                        bgcolor: getCategoryColor(item.category),
                        width: isMobile ? 40 : 48,
                        height: isMobile ? 40 : 48,
                        boxShadow: `0 2px 8px ${getCategoryColor(item.category)}40`,
                      }}
                    >
                      {getCategoryIcon(item.category)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography
                        fontWeight={500}
                        sx={{
                          fontSize: isMobile ? '0.85rem' : '1rem',
                          color: '#1a1a2e',
                        }}
                      >
                        {item.description}
                      </Typography>
                    }
                    secondary={
                      <Box
                        component="span"
                        display="flex"
                        alignItems="center"
                        gap={1}
                        mt={0.5}
                        flexWrap="wrap"
                      >
                        <Chip
                          size="small"
                          label={getCategoryLabel(item.category)}
                          sx={{
                            bgcolor: `${getCategoryColor(item.category)}15`,
                            color: getCategoryColor(item.category),
                            height: 20,
                            fontSize: '0.6rem',
                            fontWeight: 600,
                          }}
                        />

                        <Typography
                          component="span"
                          variant="caption"
                          sx={{ color: '#757575' }}
                        >
                          {new Date(item.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </Typography>
                      </Box>
                    }
                    secondaryTypographyProps={{
                      component: 'div',
                    }}
                  />

                  <ListItemSecondaryAction>
                    
                    <Typography
                      fontWeight="bold"
                      sx={{ color: item.points > 0 ? '#43a047' : '#f44336' }}
                    >
                      {item.points > 0  ? '+' : ''}{item.points}
                    </Typography>
                  </ListItemSecondaryAction>
                </ListItem>
                {index < historyData.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No points history yet
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" mt={1}>
              Start reporting environmental issues to earn points!
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
}